import { Column } from 'src/model';
import { websiteColumnList } from 'src/utils/tableColumns';

export const SET_WEBACCOUNTS_COLUMNS = 'SET_WEBACCOUNTS_COLUMNS';
export const setWebaccountsColumns = (columns: Column[]) => ({
  type: SET_WEBACCOUNTS_COLUMNS,
  payload: columns,
});

const initialState: Column[] = websiteColumnList;

interface Action {
  type: string;
  payload: Column[];
}

const setWebaccountColumnsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_WEBACCOUNTS_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};
export default setWebaccountColumnsReducer;
